export const extractTrackingDate = (inputString: string) => {
  // Regular expression to match "spent at" followed by valid date
  const regex = /spent at\s+(\b\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])\b)/i;
  const match = inputString.match(regex);

  // Return the captured date if both "spent at" and valid date exist
  return match ? new Date(match[1]) : undefined;
};

export const trackedTimeIsDefault = (spentAt: Date): boolean => {
  return (
    spentAt.getUTCHours() === 0 &&
    spentAt.getUTCMinutes() === 0 &&
    spentAt.getUTCSeconds() === 0 &&
    spentAt.getUTCMilliseconds() === 0
  );
};

export const dateFilter = (date: Date, from: Date, to: Date) =>
  date.getTime() >= from.getTime() && date.getTime() <= to.getTime();
